<template>
  <div>
    <div class="flex gap-2 border-b border-white/10 mb-4">
      <button
        v-for="tab in tabs"
        :key="tab.value"
        @click="current = tab.value"
        :class="[
          'px-4 py-2 text-sm font-medium rounded-t-md transition',
          current === tab.value
            ? 'bg-gray-800 text-white'
            : 'bg-gray-700 text-white/60 hover:text-white'
        ]"
      >
        {{ tab.label }}
      </button>
    </div>

    <div class="mt-2">
      <slot :current="current" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

const props =defineProps<{
  tabs: { label: string; value: string }[]
  initial?: string
}>()

const current = ref(props.initial ?? props.tabs[0]?.value ?? '')
</script>
